module.exports = __webpack_public_path__ + "assets/header-gradient-5425f1.svg";